import React from 'react'
import './bannerStyle.css'
import UseFetch from '../UseFetch'
import PostBanner from './PostBanner';
import mainData from '../FetchDataLinks';
import PostBannerSkeleton from './PostBannerSkeleton';

function BannerStylee() {

    let a = 1;

    const timing = setTimeout(() => {
        if (!document.getElementById('home').classList.contains('active')) {
            document.getElementById("home").className += 'active';
        }
    }, 100);

    const { blogs, loading } = UseFetch(mainData.recent)

    if (loading) {
        clearTimeout(timing)
    }

    return (
        <section className="w3l-testimonials" id="testimonials">
            <div className="testimonials pt-2 pb-5">
                <div className="container pb-lg-5">
                    <div className="owl-testimonial owl-carousel owl-theme mb-md-0 mb-sm-5 mb-4">

                        {loading && <PostBannerSkeleton key={`PostBanner${a}`} />}
                        {!loading && blogs.map((blog) => {
                            return <PostBanner key={blog.id} slug={blog.slug} image={blog.Image} Headline={blog.Headline} Content={blog.Content} Cateogary={blog.Cateogary} />
                        })}

                    </div>
                </div>
            </div>
        </section>
    )
}

export default BannerStylee
